import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useMemo, useState } from 'react';
import { axiosGetWithHeader, axiosPutWithHeader, ShowGenericAlertError } from '../../Common/axios';
import { Spinner } from 'react-bootstrap';
import { handleClickColor, timezones } from '../../Common/Util';

export function BirthTimeCorrectionTab ({menuArray,menuIndex,userData,getUserRequest}) {
  const [birthData, setBirthData] = useState([]);
  const [transitData, setTransitData] = useState([]);
  const [spinner, setSpinner] = useState('Loading - Birth Time Correction');
  const [date, setDate] = useState([]);
  const [time, setTime] = useState([]);
  const [showDegree, setShowDegree] = useState(true);
  const [showCuspal, setShowCuspal] = useState(true);
  const [msgtitle, setMsgtitle] = useState('Error');
  const [msgbody, setMsgbody] = useState('');
  const [msgbutton, setMsgbutton] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);

  const firstrowloop = [11,0,1,2];
  const secondrowloop = [10,3];
  const thirdrowloop = [9,4];
  const lastrowloop = [8,7,6,5];
  const handleDegreeVisible = ()=>setShowDegree(!showDegree);
  const handleCuspalVisible = ()=>setShowCuspal(!showCuspal);
  const handleAlertCallback = ()=>setErrorMessage(null);
  const handleReset = () => {updateChart(birthData.dateStd+"_"+birthData.time24);handleSave(birthData.dateStd+"_"+birthData.time24);}
  const trheight = {height: "12vh"};

  useMemo(() => {
    if(userData===null||userData===undefined) {
      setSpinner(null);
      return;
    }
    var clientId = userData.id;
    axiosGetWithHeader("/chart/transituserchart/"+clientId,
      (response)=>{
        setBirthData(response.data);
        setTransitData(response.data);
        setDate(response.data.dateStd);
        setTime(response.data.time24);
        updateBirthChart(response.data.birthdateStd+"_"+response.data.birthtime24);
        setSpinner(null);
      },
      (error)=>{
        console.log(error);
        setBirthData();
        setTransitData([]);
        setDate(null);
        setTime(null);
        setSpinner(null);
      }
    );

  function updateBirthChart(datetime) {
    axiosGetWithHeader("/chart/transituserchart/"+userData.id+"/"+datetime,
      (response)=>{
        setBirthData(response.data);
      },
      (error)=>{
        console.log(error);
        setBirthData([]);
      }
    );
  }

  }, [userData]);


  const handleSave = (val) => {
    const requestData = {
      id:userData.id,
      birthTime: (val===null?(date+"_"+time):val)
    }
    axiosPutWithHeader("/user/updatebirthtime", requestData,
      (response)=>{
        setMsgtitle("Birth Time Correction");
        setMsgbutton("Close");
        if(response.data.code==='200') {
          setMsgbody("Birth Time is "+(val===null?"updated":"reset")+" successfully.");
          getUserRequest(userData.runningId);
        } else {
          setMsgbody("Error occurred while updating Birth Time.");
        }
        setErrorMessage("Error");
      },
      (error)=>{
        setMsgtitle("Error");
        setMsgbody("Error occurred while saving");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );
  }

  const handleDateChange = (event) => {
    const value = event.target.value;
    if(value===null || value===undefined || value==='' || value.length<10) {
    } else {
      setDate(event.target.value);
      updateChart(value+"_"+time);
    }
  }

  const handleTimeChange = (event) => {
    const value = event.target.value;
    if(value===null || value===undefined || value==='' || value.length<8) {
    } else {
      setTime(event.target.value);
      updateChart(date+"_"+value);
    }
  }

  const updateChart = (datetime) => {
    axiosGetWithHeader("/chart/transituserchart/"+userData.id+"/"+datetime,
      (response)=>{
        setTransitData(response.data);
      },
      (error)=>{
        console.log(error);
        setTransitData([]);
        setMsgtitle("Error");
        setMsgbody("Error occurred");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );
  }
  
  return(
  <>
    {spinner===null?<></>:<div class="text-center text-primary h5 pt-5">{spinner} <Spinner animation="border" size="sm" /></div>}
    { userData===null || userData===undefined || 
      transitData===null || transitData===undefined || transitData.length===0 || 
      transitData.birthChart===null || transitData.birthChart===undefined || 
      transitData.birthChart.house===null || transitData.birthChart.house===undefined || transitData.birthChart.house.length===0 || 
      transitData.planetPosition===null || transitData.cuspalPosition===null?<div class="menupageheight"></div>:
    <Collapse in={menuArray[menuIndex]} className="m-0 p-0 ">
      <Row id="birthtimecorrection" className="m-0 p-0">
        <Col xs={12} className="m-0 p-0 pt-1">
          <Row id="birthtimecorrection1" className="m-0 p-2">
            <Col xs={0} lg={3} className="m-0 p-0">
            </Col>
            <Col xs={12} lg={6} className="m-0 p-0 text-center">
              <Row id="heading" className="m-0 p-0">
                <Col xs={6} lg={4} className="m-0 p-1 fw-bold">
                  <input type="date" maxlength="10" class="form-control" oninput="if(this.value.length > 10) this.value = this.value.replace(/\d{5,}/, match => match.substr(0, 4));" max="2999-12-31" id="datename" name="datename" value={date} onChange={(event)=>handleDateChange(event)} title='Note: Press 2 to enter 02, Press 225 to enter 25' style={{ 'letterSpacing':'0.2em' }}/>
                </Col>
                <Col xs={6} lg={4} className="m-0 p-1 fw-bold">
                  <input type="time" step="1" maxlength="10" class="form-control" id="time" name="time" value={time} onChange={(event)=>handleTimeChange(event)} title='Note: Press 4 to enter 04, Press 446 to enter 46' style={{ 'letterSpacing':'0.3em' }} />
                </Col>
                <Col xs={12} lg={4} className="m-0 p-1">
                  <table className="m-0 p-0 ps-1 pe-1 w-100 ">
                    <tr>
                      <td className="m-0 p-0 ps-1 pe-1 text-end"><button type="button" class="btn btn-outline-primary" onClick={(event)=>handleSave(null)}>Save</button></td> 
                      <td className="m-0 p-0 ps-1 pe-1 text-start"><button type="button" class="btn btn-outline-primary" onClick={handleReset}>Reset</button></td> 
                    </tr>
                  </table>
                </Col>
              </Row>  
            </Col>
            <Col xs={12} lg={3} className="m-0 p-0"></Col>
          </Row>

                  <Row id="birthtimecorrection1" className="m-0 p-0">
                    <Col xs={0} lg={4} className="m-0 p-2">
    <table class="m-0 p-0 table align-middle caption-top text-center">
      <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Birth Time Correction</h4></caption>
      <tbody class="m-0 p-0">
        <tr class="m-0 p-0" style={trheight}>
        {firstrowloop.map((firstrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary w-25" onClick={handleClickColor}>
          {transitData.birthChart.house[firstrowcol].list.map((planet) => (
            <>
              {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
                <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
              }
            </>  
          ))}
          </td>
        ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {secondrowloop.map((secondrowcol,colindex) => (
        <>
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {transitData.birthChart.house[secondrowcol].list.map((planet) => (
            <>
              {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
                <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
              }
            </>  
          ))}
          </td>
          {colindex!==0?<></>:
          <td class="m-0 p-0 text-center border-primary" colSpan="2" rowSpan="2">
            <b>RASHI CHART</b><br/>
            <br/>{userData.firstName+" "+userData.lastName}
            <br/>{transitData.date} {transitData.day} 
            <br/>{transitData.time} {timezones.find(tz => tz.value === transitData.timezone).label.substring(1,10)}
            <br/>{transitData.city}
            <br/>Lat:{transitData.latitude} Lon:{transitData.longitude}
            <br/>{transitData.ayanamsaName} : {transitData.ayanamsaDegree}
          </td>}
        </>))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {thirdrowloop.map((thirdrowcol) => (
          <td class="m-0 p-0 border border-1 border-primary" onClick={handleClickColor}>
          {transitData.birthChart.house[thirdrowcol].list.map((planet) => (
          <>
            {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
              <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
            }
          </>  
          ))}
          </td>
          ))}
        </tr>  

        <tr class="m-0 p-0" style={trheight}>
        {lastrowloop.map((lastrowcol) => (
          <td class="border border-1 p-0 border-primary" onClick={handleClickColor}>
          {transitData.birthChart.house[lastrowcol].list.map((planet) => (
          <>
            {!showCuspal&&(planet.label.length<3 || planet.label.includes("I"))?<></>:
              <>{planet.label} {showDegree && planet.relDegree} {planet.retro}<br/></>
            }
          </>
          ))}
          </td>
        ))}
        </tr>  
      </tbody>
    </table>                
    <table class="m-0 p-0 table table-borderless align-middle text-center noprint">
    <tbody class="m-0 p-0">
      <tr class="m-0 p-0" >
        <td class="m-0 p-2"></td>
        <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handleDegreeVisible}>{showDegree?"Hide":"Show"} Degree</button></td>
        <td class="m-0 p-2"><button type="button" class="btn btn-outline-primary" onClick={handleCuspalVisible}>{showCuspal?"Hide":"Show"} Cuspal</button></td>
        <td class="m-0 p-2"></td>
      </tr>
    </tbody>
    </table>
                    
              </Col>
              <Col xs={0} lg={4} className="m-0 p-2 ps-1 pe-1">
                    
                <table class="m-0 p-0 table table-bordered table-hover align-middle caption-top text-center">
                  <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Planets</h4></caption>
                  <thead class="m-0 p-0">
                    <tr class="m-0 p-0">
                      <th class="m-0 p-0">Planet</th> 
                      <th class="m-0 p-0">Sign Lord</th> 
                      <th class="m-0 p-0">Star Lord</th> 
                      <th class="m-0 p-0">Sub Lord</th> 
                      <th class="m-0 p-0">Sub Sub Lord</th> 
                    </tr>
                  </thead>
                  <tbody class="m-0 p-0">
                  {transitData.planetPosition.map((planet,index) => (
                    <tr class="m-0 p-0" onClick={handleClickColor}>
                      <th class="m-0 p-0 ps-1 bg-transparent text-start text-nowrap">{planet[0]}</th>
                      <td class={(birthData.planetPosition[index][1]===planet[1]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.planetPosition[index][1]===planet[1]?"":birthData.planetPosition[index][1]+"=>")+planet[1]}</td>
                      <td class={(birthData.planetPosition[index][2]===planet[2]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.planetPosition[index][2]===planet[2]?"":birthData.planetPosition[index][2]+"=>")+planet[2]}</td>
                      <td class={(birthData.planetPosition[index][3]===planet[3]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.planetPosition[index][3]===planet[3]?"":birthData.planetPosition[index][3]+"=>")+planet[3]}</td>
                      <td class={"bg-transparent m-0 p-0"} >{(birthData.planetPosition[index][4]===planet[4]?"":birthData.planetPosition[index][4]+"=>")+planet[4]}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>                    
              </Col>
              <Col xs={0} lg={4} className="m-0 p-2 ps-1 pe-1">
                    
                <table class="m-0 p-0 table table-bordered table-hover align-middle caption-top text-center">
                  <caption class="m-0 p-0" ><h4 class="m-0 p-0 pt-2 pb-1">Cuspal</h4></caption>
                  <thead class="m-0 p-0">
                    <tr class="m-0 p-0">
                      <th class="m-0 p-0">House</th> 
                      <th class="m-0 p-0">Sign Lord</th> 
                      <th class="m-0 p-0">Star Lord</th> 
                      <th class="m-0 p-0">Sub Lord</th> 
                      <th class="m-0 p-0">Sub Sub Lord</th> 
                    </tr>
                  </thead>
                  <tbody class="m-0 p-0">
                  {transitData.cuspalPosition.map((planet,index) => (
                    <tr class="m-0 p-0" onClick={handleClickColor}>
                      <th class="m-0 p-0 ps-1 bg-transparent text-start text-nowrap">{planet[0]}</th>
                      <td class={(birthData.cuspalPosition[index][1]===planet[1]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.cuspalPosition[index][1]===planet[1]?"":birthData.cuspalPosition[index][1]+"=>")+planet[1]}</td>
                      <td class={(birthData.cuspalPosition[index][2]===planet[2]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.cuspalPosition[index][2]===planet[2]?"":birthData.cuspalPosition[index][2]+"=>")+planet[2]}</td>
                      <td class={(birthData.cuspalPosition[index][3]===planet[3]?"bg-transparent":"bg-danger")+" m-0 p-0"} >{(birthData.cuspalPosition[index][3]===planet[3]?"":birthData.cuspalPosition[index][3]+"=>")+planet[3]}</td>
                      <td class="bg-transparent m-0 p-0" >{(birthData.cuspalPosition[index][4]===planet[4]?"":birthData.cuspalPosition[index][4]+"=>")+planet[4]}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>                    
                    
              </Col>
          </Row>
        </Col>
      </Row>    

    </Collapse>
    }
    <ShowGenericAlertError errorAlert={errorMessage} setErrorAlert={setErrorMessage} msgtitle={msgtitle}
      msgbody={msgbody} msgbutton={msgbutton} callback={handleAlertCallback}/>
  </>  
  );
}